import { GlobalLoader } from '@juvare/common-web-ui/GlobalLoader';
import { usePublicSettingsLoader, useSettingsLoader } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useAppManifestLoader, usePlatformLoader } from '@juvare/platform-sdk-react/ui/hooks';
import { isUserLoggedIn } from '@juvare/platform-sdk-react/ui/stores';
import { combineLoadingStatuses } from '@juvare/platform-sdk-react/ui/utils';
import React from 'react';
import { useSelector } from 'react-redux';
import { AnonymousApp } from './AnonymousApp';
import { AppContext } from './Context';
import { UserApp } from './UserApp';

export const App: React.FC = () => {
    const status = combineLoadingStatuses([
        useAppManifestLoader(),
        usePlatformLoader({ appContext: AppContext }),
        usePublicSettingsLoader(),
        useSettingsLoader(),
    ]);
    const userLoggedIn = useSelector(isUserLoggedIn);

    if (status !== 'done') {
        return <GlobalLoader />;
    }

    return userLoggedIn ? <UserApp /> : <AnonymousApp />;
};
